module.exports = __webpack_public_path__ + "img/google-icon.9d9011cd.png";